import React, { useState } from 'react';
import { Mail, Check, Loader2 } from 'lucide-react';
import { useTranslation } from '../context/TranslationContext';

// Always-available newsletter signup (so the popup can stay rare).
export const FooterNewsletter = function() {
  var { t, language } = useTranslation();
  var [email, setEmail] = useState('');
  var [status, setStatus] = useState('idle');
  var [error, setError] = useState('');

  async function submit(e) {
    e.preventDefault();
    var value = (email || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setError(t('newsletterInvalid'));
      return;
    }
    setError(''); setStatus('sending');
    try {
      var res = await fetch(process.env.REACT_APP_BACKEND_URL + '/api/newsletter/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: value, language: language, source: 'footer' }),
      });
      var data = await res.json().catch(function() { return {}; });
      if (!res.ok) throw new Error((data && data.detail) || 'error');
      setStatus(data.already_subscribed ? 'already' : 'done');
      try { localStorage.setItem('jimendez_newsletter_v1', 'subscribed'); } catch (err) { /* private mode */ }
    } catch (err) {
      setStatus('idle');
      setError(t('newsletterError'));
    }
  }

  var subscribed = status === 'done' || status === 'already';

  return (
    <div data-testid="footer-newsletter" className="border-t border-white/5 mt-12 pt-10">
      <div className="flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-12">
        <div className="lg:flex-1">
          <div className="flex items-center gap-2 mb-2">
            <Mail className="w-4 h-4 text-[#d4af37]" />
            <span className="text-[#d4af37] text-[11px] font-semibold uppercase tracking-[0.18em]">
              {t('newsletterKicker')}
            </span>
          </div>
          <h4 className="text-white text-base md:text-lg font-semibold mb-1">{t('newsletterTitle')}</h4>
          <p className="text-neutral-500 text-sm leading-relaxed max-w-lg">{t('newsletterSubtitle')}</p>
        </div>

        {subscribed ? (
          <div data-testid="footer-newsletter-success" className="flex items-center gap-2 text-[#d4af37] text-sm font-semibold lg:w-[380px]">
            <Check className="w-4 h-4" />
            {status === 'already' ? t('newsletterAlready') : t('newsletterThanks')}
          </div>
        ) : (
          <form onSubmit={submit} className="lg:w-[380px] flex-shrink-0">
            <div className="flex gap-2">
              <input
                type="email"
                value={email}
                onChange={function(e) { setEmail(e.target.value); setError(''); }}
                placeholder={t('newsletterPlaceholder')}
                data-testid="footer-newsletter-input"
                autoComplete="email"
                className="flex-1 min-w-0 bg-neutral-900 border border-white/10 text-white text-sm rounded-full px-4 py-3 placeholder-neutral-600 focus:outline-none focus:border-[#d4af37] transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'sending'}
                data-testid="footer-newsletter-btn"
                className="flex-shrink-0 inline-flex items-center gap-2 bg-[#d4af37] hover:bg-white text-black font-semibold text-sm rounded-full px-5 py-3 transition-colors disabled:opacity-60"
              >
                {status === 'sending' ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                {t('newsletterCta')}
              </button>
            </div>
            {error ? (
              <p data-testid="footer-newsletter-error" className="text-red-400 text-xs mt-2">{error}</p>
            ) : null}
          </form>
        )}
      </div>
    </div>
  );
};

export default FooterNewsletter;
